<style>
 body{
   margin:0;
   padding: 0;
   background: #ececec;
 }
html,body,#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width:100%;
  height:100%;
  background: #ececec;
  /* color: #2c3e50; */
}
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.el-image{
  width: 25px !important;
  height: 25px !important;
  line-height: 25px;

}
 .el-cascader-menu__wrap{
    height: 300px;
  }
/* .el-table td, .el-table th.is-leaf{
  border-bottom:1px solid #c7c7c7
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right:1px solid #c7c7c7
}
.el-table__body-wrapper, .el-table__footer-wrapper, .el-table__header-wrapper{
  width: calc(100% - 2px);
  border: 1px solid #c7c7c7;
  border-top: 0;
} */
.dev_bottom {
  	/* color: #999999;
  	font-size: 12px;
  	width: 100%;
  	height: 40px;
  	line-height: 40px;
    margin-bottom: 20px; */
    display: none;
 }
.orderItemWrapper .checked_box .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input .el-checkbox__inner{
border-color: #6376f7;
}
/* .checked_box .el-checkbox__input.is-checked + .el-checkbox__label {
color: #666;
}
.checked_box .el-checkbox.is-bordered.is-checked{
border-color: RED;
}
.checked_box .el-checkbox__input.is-focus .el-checkbox__inner{
border-color: #666;
}
.checked_box .el-table-filter__list {
   max-height: 500px;
   overflow: auto;
 } */
 @media screen and (max-width:500px ) {
 	.dev_bottom {
      display: block;
 		  color: #999999;
	  	font-size: 12px;
	  	width: 100%;
	  	padding: 10px 0;
	  	text-align: center;
	  	line-height: 20px;
	  	margin-bottom: 20px;
 	}
 	.dev_bottom > span {
 		display: inline-block;
 		height: auto !important;
 	}
 }
</style>

<template>
  <div id="app">
  	<guigui-nav class='hidden-xs-only' v-show='!fromClient&&!backendNav'  ref="nav" :now='now' @changeNow='changeNow' :title='title'></guigui-nav>
    <backEndNav class='hidden-xs-only' v-show='!fromClient&&backendNav' :now='now' @changeNow='changeNow' :title='title'></backEndNav>
    <!-- <index ref="index"   v-if='now=="用户案例"' @changeNow='changeNow'></index> -->
    <!-- <the-world v-if='now=="全球分布"'></the-world> -->
    <!-- <about v-show='now=="关于我们"'></about> -->
    <!-- <House v-if="now=='包小区'" :now='now'></House> -->
    <!-- <MeasureAndInstall v-if="now=='测量安装'" /> -->
    <!-- <cloudStore v-show='now == "加盟云仓"'></cloudStore> -->
    <!-- <Shop ref="shop" v-if="now == '云仓商城'"></Shop> -->
    <!-- <PersonCenter v-if="now == '个人中心'"></PersonCenter> -->
    <!-- <VipService v-if="now == '加入云仓'" @changeNow='changeNow'></VipService> -->
    <!-- <cloudIndex v-if="now == '首页'" @changeNow='changeNow'></cloudIndex> -->
    <!-- <cloudSupplier @changeNow='changeNow' v-if='now=="供应商管理"'></cloudSupplier> -->
    <!-- <cloudGoodsManage v-if='now=="商品管理"'></cloudGoodsManage> -->
    <!-- <OrderQuery v-if="now == '订单查询'" /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <hobaoImport v-if="endTime && showHbImport"></hobaoImport>
    <Foot v-show='!fromClient&&!noFooter'></Foot>
    <p v-show='!fromClient&&!noFooter' class="dev_bottom"><span style="cursor: pointer;" @click="gotoBeian">2010-2020 SiteStar,All Rights Reserved.&nbsp;&nbsp;江苏新格尔人居科技有限公司&nbsp;&nbsp;苏ICP备14034668号-33</span></p>
  </div>
</template>


<script>
// import Vconsole from 'vconsole';
// new Vconsole();
import hobaoImport from './view/hobaoImport'
import nav from './components/Nav.vue'
import backEndNav from './components/BackEndNav.vue'
import index from './view/index.vue'
import join from './view/join.vue'
import about from './view/about.vue'
import theWorld from './view/theWorld.vue'
import cloudStore from './view/cloudStore'
import House from './view/House.vue'
import MeasureAndInstall from './view/measureAndInstall.vue'
import Shop from './view/cloud/CloudShop'
// import PersonCenter from './view/cloud/CloudPersonCenter'
import OrderQuery from './view/cloud/OrderQuery'
import cloudIndex from './view/cloud/CloudIndex'
import cloudSupplier from './view/cloud/cloudSupplier'
import cloudGoodsManage from './view/cloud/CloudGoodsManage.vue'
import Foot from './components/Foot'
import { mapMutations, mapState } from 'vuex'
import autoLogin from './util/autoLogin.js'
export default {
  name: 'App',
  data(){
    return{
      // now:"首页",//当前页
      title:'',
      showHbImport:true
    }
  },
  computed:{
    endTime(){
      let endeTime = 1613610000
      let nowTime = Math.round(new Date() / 1000)
      if((endeTime - nowTime) > 0){
        return 1
      }else{
        return 0
      }
    },
    now(){
      return this.$store.state.navNow
    },
    fromClient(){
      return this.$store.state.fromClient
    },
    backendNav(){
      return this.$store.state.backendNav
    },
    noFooter(){
      return this.$store.state.noFooter
    },
  },
  components: {
    hobaoImport,
    "guigui-nav":nav,//导航
    backEndNav,
    index,//首页
    join,//工厂入驻
    about,//关于我们
    "the-world":theWorld,//全球分布
    cloudStore,
    House,
    MeasureAndInstall,//测量安装
    // 新页面
    Shop,
    // PersonCenter,
    OrderQuery,
    // VipService,
    cloudIndex,
    cloudSupplier,
    cloudGoodsManage,
    Foot
  },
  methods:{
    ...mapMutations([
      'initUserInfo', 'changePage','setFromClient', 'initShopCar'
    ]),
    query(attr) {
	    return new URLSearchParams(window.location.search.replace('?', '')).get(attr)
	  },
  	gotoBeian() {
  		window.open('http://www.beian.miit.gov.cn/')
  	},
    changeNow(now){
      // this.now = now
      this.$router.replace({name: 'emptyPage'});
      this.$store.commit('changeNavNow',now)
      this.$post("/user/action_log",{
        data:JSON.stringify({
        uid:localStorage.getItem('data')?JSON.parse(localStorage.getItem('data')).id:-1,
        platform:6,
        type:"柜柜圈",
        sub_type:now,
        value:""
      })},res => {})

    },
    // logout(){
    //   this.$refs.index.logout();
    // },
    // logon(){
    //   this.$refs.nav.logon();
    //   if(this.now == '云仓商城'){
    //     this.$refs.shop.logon();
    //   }
    // }
  },
  async created() {
    // 获取是否显示抢红包入口
    if(!localStorage.showHbImport || !Number(localStorage.showHbImport)){
      this.showHbImport = true
    }else{
      this.showHbImport = false
    }
    let that=this
    let param=autoLogin.getUrlVars()
    if(param.hasOwnProperty('fromClient')&&param.fromClient!=''){
        that.setFromClient(true)
    }
    that.$get("/guigui/exhibition/countFactoryGroup",{},()=>{})

    // 获取登录信息，写入到store里
    // console.log(1)
    await this.initUserInfo();
    // console.log(1)
    if(that.query('now')){
      that.changeNow(that.query('now'))
    }

    // 初始化购物车数据到store
    this.initShopCar();

  },
  mounted(){
    // console.log(3)
  }
}
</script>
